<template>
  <div>
   <div class="top-btn">
      <vxe-toolbar perfect v-if="this.$slots.btn">
        <template v-slot:buttons>
          <slot name="btn"></slot>
        </template>
      </vxe-toolbar>
    </div>
    <vxe-table
      border
      stripe
      show-overflow
      :highlight-current-row="highlightCurrentRow"
      :max-height="tableheight"
      row-id="id"
      row-key
      ref="xTree"
      :resizable="resizable"
      :loading="loading"
      :data.sync="list"
      :context-menu="{header: {options: headerMenus}, body:{options: bodyMenus}}"
      @context-menu-click="contextMenuClickEvent"
      :mouse-config="{selected: true}"
      :keyboard-config="{isArrow: true, isDel: true, isTab: true, isEdit: true}"
      :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
      :tree-config="{children: 'children', expandAll: expandAll}"
      @edit-actived="editActived"
      @edit-closed="editClosed"
      @cell-click="cellClickEvent"
      :toolbar="toolbar"
      :show-footer="showfooter"
      :footer-method="footerMethod">
      <vxe-table-column v-for="(col,index) in flexcols"
                        :key="index"
                        :type="col.type"
                        :field="col.field"
                        :title="col.title"
                        :tree-node="col.type ==='index'? true:false"
                        :edit-render="col.editRender"
                        :formatter="col.fieldtype==='D'? ['toDateString', 'yyyy-MM-dd']:
                          col.fieldtype==='T'? 'toDateString':''">

      </vxe-table-column>
    </vxe-table>
    <div v-if="showPage">
      <vxe-pager
        :loading="loading"
        :current-page="tablePage.currentPage"
        :page-size="tablePage.pageSize"
        :total="tablePage.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange">
      </vxe-pager>
    </div>
  </div>
  <!--:pager-config="tablePage"-->
  <!--@page-change="handlePageChange"-->

</template>
<script>
  import XEUtils from 'xe-utils'
  import request from  '@/utils/request'
  import * as calUtils from '../../assets/js/calUtils'
  import Sortable from 'sortablejs'
  import VxeTableColumn from "vxe-table/packages/column/src/column"
  export default {
    components: {VxeTableColumn},
    name: "vgtree",
    props:{
      tableheight: 0,
      flexname: '',
      resizable: {},
      expandAll: false,
      list: {},
      cols: {},
      total: 0,
      showfooter: {},
      showPage: {},
      needBlackRow: {},
      activeCell: {}
    },
    data () {
      return {
        highlightCurrentRow: true,
        loading: false,
        tableData: [],
        flexcols: [],
        customColumns: [],
        showHelpTip1: false,
        headerMenus: [
          [
            {
              code: 'showAllColumn',
              name: '取消所有隐藏列'
            },
            {
              code: 'hideColumn',
              name: '隐藏列'
            }
          ]],
        bodyMenus: [
          [
            {
              code: 'addBlackRows',
              name: '添加行'
            },
            {
              code: 'addFiveBlackRows',
              name: '添加5行'
            },
            {
              code: 'removeBlackRows',
              name: '删除行'
            },
            {
              code: 'insertBlackRows',
              name: '插入行'
            },
            {
              code: 'insertFiveBlackRows',
              name: '插入5行'
            }
          ]
        ],
        tablePage: {
          total: this.total,
          currentPage: 1,
          pageSize: 20
        },
        toolbar: {
          id: 'vggridtoolbar',
          refresh: true,
          resizable: {
            storage: true
          },
          setting: {storage: true}
        }
      }
    },
    activated () {
      //通过flexname获取flexcols,否则，从外面获取表格
      console.log('ddd')
      setTimeout(() => {
        if (!this.flexname) {
          this.flexcols = this.cols
        } else {
          this.getFlexcols()
        }
        if (!this.needBlackRow) {
          this.bodyMenus = []
        }
        //此处加载对应的下拉框数据
        this.loadComboData()
        this.setSelectRows()
      },100)
    },
    mounted () {
      this.$emit('getxTree', this.$refs.xTree)
    },
    watch: {
      total (val1,val2) {
        this.tablePage.total = val1
      },
      pageSize (val1,val2) {
        this.tablePage.pageSize = val1
      }
    },
    methods: {
      async setSelectRows() {
        let checkRowKeys = []
        setTimeout(() => {
          this.list.forEach(item => {
            if (item.selected) {
              checkRowKeys.push(item)
            }
          })
          this.$refs.xTree.setSelection(checkRowKeys,true)
        }, 300)
      },
      async getFlexcols() {
        this.flexcols = [
          { type: 'selection',calculExpr:'', width: 60 },
          { type: 'index', title: '行号',calculExpr:'', width: 80 },
          { field: 'lecode', title: '货物编码',calculExpr:'', minWidth: 140, editRender: { name: 'ElInput', props: { readonly: true,suffixIcon: 'el-icon-search'}},sortable:true},
          { field: 'lename', title: '货物名称',calculExpr:'', minWidth: 140},
          { field: 'leunitid', title: '计量单位',calculExpr:'', minWidth: 140, editRender: { name: 'select',options: [] } },
          { field: 'ledate', title: '交货日期',calculExpr:'', width: 250, editRender: { name: 'ElDatePicker', props: { type: 'date', format: 'yyyy/MM/dd' } }},
          { field: 'leqty', title: '数量',calculExpr:'', triggercol: 1, width: 160, editRender: { name: 'input'} },
          { field: 'leprice', title: '单价',calculExpr:'', triggercol: 1,width: 160, editRender: { name: 'ElInput'} },
          { field: 'leamt', title: '金额', calculExpr:'leqty*leprice', width: 160},
          { field: 'remark', title: '备注',calculExpr:'', width: 200}
        ]
      },
      async loadComboData () {
        this.flexcols.forEach(async item => {
          if (item.syscode) {
            let options = await request({
              url: '/kfgl/syscode/getSysCodeList',
              method: "get",
              params: item
            })
            this.flexcols[this.findTableColumnIndexByField(item.field)].editRender.options = options
          }
        })
      },
      cellClickEvent(row,column) {
        this.$emit('cellClick', row, this.$refs.xTree)
      },
      findTableColumnIndexByField(field) {
        let columnIndex = this.flexcols.findIndex(item => item.field === field)
        return columnIndex
      },
      editActived () {
        this.highlightCurrentRow = false
      },
      editClosed (row) {
        console.log(this.$refs.xTree.getRowIndex(row))
        let that  = this
        //if (that.flexcols[row.columnIndex].addNewRowFlg) {
        //if (row.$rowIndex ===-1 && that.list[row.rowIndex][that.flexcols[row.columnIndex].field]) {
        //this.$refs.xTree.insertAt(row, -1)
        // .then(({ row }) => this.$refs.xTree.setActiveCell(row, 'name'))
        //}
        //}
        if (that.flexcols[row.columnIndex].triggercol ===1) {
          that.flexcols.forEach(function (item,index,arr) {
            if (arr[index].calculExpr !=='') {
              that.calculColValue(arr[index].field,arr[index].calculExpr, ['leqty','leprice'],row.rowIndex)
            }
          })
        }
        this.highlightCurrentRow = true
      },
      calculColValue (calField,expr, triggerCols, rowIndex) {
        let that = this
        triggerCols.forEach(function (item, index) {
          let colValue = that.list[rowIndex][item]
          expr = expr.replace(item, colValue)
        })
        let result = calUtils.calStr(expr)
        that.setValueToCell(rowIndex,calField,result)
      },
      setValueToCell (rowIndex,calField,val) {
        this.list[rowIndex][calField] = Number(Number(val).toFixed(2))
        this.$refs.xTree.updateFooter()
      },
      getObjectValueByKeyStr(obj,field) {
        let value
        Object.keys(obj).forEach(function (key, index) {
          if (key === field) {
            let values = Object.values(obj)
            value = values[index]
          }
        })
        return value
      },
      handlePageChange ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.$emit('pagechange', this.tablePage)
      },
      contextMenuClickEvent ({ menu, row, column }) {
        let xTree = this.$refs.xTree
        switch (menu.code) {
          case 'removeBlackRows':
            this.$refs.xTree.remove(row)
            break
          case 'insertBlackRows':
            this.$refs.xTree.insertAt({},row)
              .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            break
          case 'insertFiveBlackRows':
            for (let i=0;i<5;i++) {
              this.$refs.xTree.insertAt({},row)
                .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            }
            break
          case 'addBlackRows':
            this.$refs.xTree.insertAt({}, -1)
              .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            break
          case 'addFiveBlackRows':
            for (let i=0;i<5;i++) {
              this.$refs.xTree.insertAt({}, -1)
                .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            }
            break
          case 'hideColumn':
            console.log(column)
//            this.$refs.xTree.hideColumn(column)
            column.visible=false
            this.$refs.xTree.refreshColumn()
            break
          case 'showAllColumn':
            let that = this
            let columns = that.$refs.xTree.getTableColumn()
            that.$refs.xTree.getTableColumn().forEach(function (item) {
              item.visible= true
            })
            that.$refs.xTree.refreshColumn()
            break
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计'
            }
            //合计列需要放到表格头部存储
            if (['leqty','leamt'].includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return ''
          })
        ]
      },
      rowDrop () {
        console.log('dddd')
        this.$nextTick(() => {
          let xTree = this.$refs.xTree
          this.sortable = Sortable.create(xTree.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              let currRow = this.tableData.splice(oldIndex, 1)[0]
              this.tableData.splice(newIndex, 0, currRow)
            }
          })
        })
      }
    }
  }
</script>
<style scoped>
</style>
